import colors from './colors';

const defaultTheme = {
  color: colors
};

export default defaultTheme;